const getPublicEnv = (key, fallback = '') => {
  if (typeof process === 'undefined') return fallback
  const value = process.env[key]
  return value && value.length > 0 ? value : fallback
}

export const APIURL                  = getPublicEnv('NEXT_PUBLIC_APIURL', 'https://services.kalpvruks.com/')
export const ACCORD_NEWAPI_URL       = getPublicEnv('NEXT_PUBLIC_ACCORD_NEWAPI_URL', 'http://news.accordwebservices.com/')
export const ACCORD_WORLD_INDICES_URL = getPublicEnv('NEXT_PUBLIC_ACCORD_WORLD_INDICES_URL', 'http://stock.accordwebservices.com/Stock/GetWorldIndices')
export const LTP_SOCKET_URL          = getPublicEnv('NEXT_PUBLIC_LTP_SOCKET_URL', 'wss://wss.kalpvruks.com')
export const SOCKET_CONNECT_TOKEN    = getPublicEnv(
  'NEXT_PUBLIC_SOCKET_CONNECT_TOKEN',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE4MTI1OTA3NzEsImRhdGEiOnsiQ0xJRU5USUQiOiIxQUcyNyIsIkFUeXBlIjoiQ0xJRU5UIiwiaXAiOiIifSwiaWF0IjoxNjkyNTkwODMxfQ.nqmaaQoWEtus3M4HBiE916k4xXCVJ8--MRPT_DuTI5I'
)
// wss://chat.kalpvruks.com // ws://localhost:8767
export const CHAT_SOCKET_URL = getPublicEnv('NEXT_PUBLIC_CHAT_SOCKET_URL', 'wss://chat.kalpvruks.com')

// CHAT_UPLOAD_URL: HTTP base for the upload endpoint (same host as WS server, different protocol).
// If not explicitly set, derive it from CHAT_SOCKET_URL by converting ws:// → http://
// so you only need ONE env var for the chat server host.
const rawChatUpload = getPublicEnv('NEXT_PUBLIC_CHAT_UPLOAD_URL', '')
// wss:// must map to https:// — collapsing both schemes to http:// downgrades
// uploads to cleartext and, from an HTTPS page, gets them blocked as mixed
// content, so file sending fails as soon as the app is served over TLS.
export const CHAT_UPLOAD_URL = rawChatUpload
  || CHAT_SOCKET_URL.replace(/^wss:\/\//, 'https://').replace(/^ws:\/\//, 'http://')
